"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _transparentize = _interopRequireDefault(require("polished/lib/color/transparentize"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _usePalette2 = _interopRequireDefault(require("../styles/PaletteProvider/usePalette"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var transparentize30 = (0, _transparentize.default)(0.3);

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2.default)(),
      colors = _useTheme.colors,
      fonts = _useTheme.fonts,
      breakpoint = _useTheme.breakpoint;

  var _usePalette = (0, _usePalette2.default)(),
      typography = _usePalette.typography;

  var color = transparentize30(colors[typography.titleEmphasis]);
  return {
    root: {
      display: 'inline',
      textAlign: 'center',
      maxWidth: breakpoint.values.md
    },
    text: _objectSpread({}, fonts.primary, {
      color: colors[typography.paragraph],
      fontWeight: 'bold',
      display: 'inline',
      whiteSpace: 'pre-wrap',
      backgroundImage: "linear-gradient(\n        transparent 0%,\n        transparent 50%,\n        ".concat(color, " 50%,\n        ").concat(color, " 100%,\n        transparent 50%,\n        transparent\n      )"),
      '&:after': {
        content: '""',
        display: 'block'
      }
    })
  };
};

__signature__(useStyles, "useTheme{{ colors, fonts, breakpoint }}\nusePalette{{ typography }}", function () {
  return [_useTheme2.default, _usePalette2.default];
});

var Highlight = function Highlight(props) {
  var children = props.children,
      other = (0, _objectWithoutProperties2.default)(props, ["children"]);
  var classes = useStyles();
  return (0, _core.jsx)(_Flex.default, (0, _extends2.default)({
    css: classes.root,
    margin: [4, 2]
  }, other), (0, _core.jsx)("em", {
    css: classes.text
  }, children));
};

__signature__(Highlight, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = Highlight;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(transparentize30, "transparentize30", "/builds/bA1zbJom/0/gojob/ui-bits/src/Highlight/index.tsx");
  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/Highlight/index.tsx");
  reactHotLoader.register(Highlight, "Highlight", "/builds/bA1zbJom/0/gojob/ui-bits/src/Highlight/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Highlight/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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